var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25C6.89 21.25 2.75 17.11 2.75 12C2.75 6.88 6.89 2.75 12 2.75C17.1 2.75 21.25 6.88 21.25 12C21.25 17.11 17.1 21.25 12 21.25Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 6.88 6.89 2.75 12 2.75C17.1 2.75 21.25 6.88 21.25 12C21.25 17.11 17.1 21.25 12 21.25C6.89 21.25 2.75 17.11 2.75 12Z",
    stroke: "#F25353",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 9.58L13.35 9.55C13.64 9.25 14.11 9.25 14.41 9.54C14.71 9.83 14.71 10.3 14.42 10.6L14.39 10.6L13.35 9.58ZM10.64 14.41L10.64 14.44C10.34 14.74 9.88 14.74 9.58 14.45C9.28 14.16 9.28 13.69 9.57 13.39L9.6 13.39L10.64 14.41Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.88 10.08L10.1 13.91",
    stroke: "#F25353",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 10.6L9.57 10.6C9.28 10.3 9.28 9.83 9.58 9.54C9.88 9.25 10.34 9.25 10.64 9.55L10.64 9.58L9.6 10.6ZM14.39 13.39L14.42 13.39C14.71 13.69 14.71 14.16 14.41 14.45C14.11 14.74 13.64 14.74 13.35 14.44L13.35 14.41L14.39 13.39Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 10.08L13.88 13.91",
    stroke: "#F25353",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.d1ebde3ec7517f433792b94dec23d4e8.svg";
export { ForwardRef as ReactComponent };